import { AxiosPublicationsInstance } from "../api/AxiosInstance";

// Mostrar noticias
export const showNotices = async () => {
  try {
    const response = await AxiosPublicationsInstance.get(`api/mostrar/alertas-nomada`);
    return response;
  } catch (error) {
    throw error?.response || "Failed getting notices";
  }
};